import React from 'react';

import { SubHeading } from '../../components';
import {images} from '../../constants'
import './Chef.css';

const Chef = () => (
  <div className='app__bg app__wrapper section__padding'>
    <div className="app__wrapper_img app_wrapper_img_reverse">
      <img src={images.chef} alt="chef" />
    </div>

    <div className="app__wrapper_info">
      <SubHeading title="Chef's Word" />
      <h1 className="headtext__cormorant">What We Believe In</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote" />
          <p className="p__opensans">Prima zril primis eu sed, mei ei eirmod moderatius adversarium.</p>
        </div>
        <p className="p__opensans">Pri posse graeco definitiones cu, id eam populo quaestio adipiscing, usu quod malorum te. His cu probo blandit. Vivendum intellegat et qui, ei denique consequuntur vix. Vivendum intellegat et qui, ei denique consequuntur vix.</p>
      </div>

      <div className="app__chef-sign">
        <p>Kevin Luo</p>
        <p className='p__opensans'>Head Chef</p>
        <img src={images.sign} alt="signature" />
      </div>
    </div>

  </div>
);

export default Chef;
